module.exports = __webpack_public_path__ + "img/Combat.34b7cf33.png";